import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import { DefaultPageProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';

import HomeButton from 'src/components/atoms/button/HomeButton';
import { LinkButton } from 'src/components/atoms/button/Button';

type Props = DefaultPageProps;

class BakedBreadCompletePage extends Component<Props> {
  render() {
    return (
      <DefaultLayout {...this.props}>
        <Styled>
          <div>
            <Heading>＼ 焼き上がりを通知するパンの情報を更新しました ／</Heading>
            <Lead>sacriのアプリから、内容を確認してください</Lead>
            <Controller>
              <LinkButton
                url={'/baked_breads'}
                text="続けて別のパンを編集する"
                isDisabled={false}
              />
              <HomeButton />
            </Controller>
          </div>
        </Styled>
      </DefaultLayout>
    );
  }
}

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 52px);
`;

const Heading = styled.h3`
  color: ${StyleConfig.COLOR.PRIMARY};
  font-size: 18px;
  text-align: center;
`;
const Lead = styled.p`
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  font-size: 14px;
  line-height: ${24 / 14};
  text-align: center;
  margin-top: 16px;
`;
const Controller = styled.div`
  margin-top: 40px;
  > * {
    margin-top: 16px;
  }
`;

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BakedBreadCompletePage);
